import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CredentialStatus, IssuerStatus, statusColors, getStatusTranslation } from '@sphereon/ui-components.core';
import SSICheckmarkBadge from '../../../components/assets/badges/SSICheckmarkBadge';
import SSIExclamationMarkBadge from '../../../components/assets/badges/SSIExclamationMarkBadge';
import { SSIStatusLabelBadgeContainer as BadgeContainer, SSIStatusLabelContainerStyled as Container, SSIStatusLabelStatusCaptionStyled as StatusCaption, } from '../../../styles';
const SSIStatusLabel = (props) => {
    const { status, color = statusColors[status], style, showIcon = false } = props;
    return (_jsxs(Container, { style: { ...style, borderColor: color }, children: [showIcon && _jsx(BadgeContainer, { children: getStatusBadge(status, color) }), _jsx(StatusCaption, { style: { color }, children: getStatusTranslation(status) })] }));
};
const getStatusBadge = (status, backgroundColor) => {
    switch (status) {
        case IssuerStatus.VERIFIED:
            return _jsx(SSICheckmarkBadge, { backgroundColor: backgroundColor });
        case IssuerStatus.UNVERIFIED:
            return _jsx(SSIExclamationMarkBadge, { backgroundColor: backgroundColor });
        case CredentialStatus.VALID:
            return _jsx(SSICheckmarkBadge, { backgroundColor: backgroundColor });
        case CredentialStatus.EXPIRED:
            return _jsx(SSIExclamationMarkBadge, { backgroundColor: backgroundColor });
        case CredentialStatus.REVOKED:
            throw new Error(`${status} not yet implemented`);
        default:
            throw new Error(`${status} not supported`);
    }
};
export default SSIStatusLabel;
